export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let str = val == null ? "" : String(val);
    if (str.includes('"')) str = str.replace(/"/g, '""');
    return `"${str}"`;
  };

  let csv = headers.map(escape).join(",") + "\r\n";

  objArray.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

export function exportGuestCountsByHourCSV(
  transactions,
  countTransaction,
  selectedDate,
  fileName
) {
  // 1) count per hour (imports your existing logic)
  const counts = countTransaction;

  // 2) build rows
  const headers = [
    "Date",
    "Hour",
    "Solo",
    "Couple",
    "Small Group",
    "Medium Group",
    "Large Group",
  ];

  const csvRows = [headers.join(",")];

  // assume counts.solo.length entries
  counts.solo.forEach((_, index) => {
    const hourLabel = `${index + 5}:00`;
    const row = {
      Date: selectedDate,
      Hour: hourLabel,
      Solo: counts.solo[index],
      Couple: counts.couple[index],
      "Small Group": counts.smallGroup[index],
      "Medium Group": counts.meduimGroup[index],
      "Large Group": counts.largeGroup[index],
    };
    csvRows.push(Object.values(row).join(","));
  });

  // 3) download
  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const name = fileName || `TotalGuests_${selectedDate}.csv`;
  link.href = URL.createObjectURL(blob);
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
